export interface ChangelogRelease {
  version: string;
  date: string;
  title: string;
  body: string;
}

const RELEASE_HEADER =
  /^## \[([^\]]+)\]\s*-\s*(\d{4}-\d{2}-\d{2})(?:\s*-\s*(.+))?$/;

/**
 * Split repository CHANGELOG.md into structured release entries.
 * Supports headers with or without a trailing title segment.
 */
export function parseChangelog(markdown: string): ChangelogRelease[] {
  const releases: ChangelogRelease[] = [];
  const chunks = markdown.split(/\n(?=## \[)/);

  for (const chunk of chunks) {
    const trimmed = chunk.trim();
    if (!trimmed.startsWith('## [')) continue;

    const lines = trimmed.split('\n');
    const headerMatch = lines[0].match(RELEASE_HEADER);
    if (!headerMatch) continue;

    const body = lines
      .slice(1)
      .join('\n')
      .replace(/^\s*---\s*$/gm, '')
      .trim();

    releases.push({
      version: headerMatch[1],
      date: headerMatch[2],
      title: (headerMatch[3] || '').trim(),
      body,
    });
  }

  return releases;
}
